import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmploymentContractTemplate  {
    _originalTypeClassName = "zERP.BO.EmploymentContractTemplate";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmploymentContractTemplate.translate = translateService;
}
this.BasicSalaries = [];
this.MainSalaries = [];
this.OtherSalaries = [];
this.Deductions = [];
this.Contributions = [];
this.SalaryPeriodConfig = [];
this.Id = null;
this.Name = null;
this.IsActive = false;
this.Description = null;
this.EnableAdvancePayment = false;
this.IsAdvancePaymentPercentage = false;
this.AdvancePaymentPercentage = null;
this.AdvanceRoundingAmount = null;
this.Code = null;
this.AdvanceRoundingAmountMethod = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
IsActive:any;
Description:any;
EnableAdvancePayment:any;
IsAdvancePaymentPercentage:any;
AdvancePaymentPercentage:any;
AdvanceRoundingAmount:any;
Code:any;
AdvanceRoundingAmountMethod:any;
ContractType:any;
BasicSalaries:any;
MainSalaries:any;
OtherSalaries:any;
Deductions:any;
Contributions:any;
SalaryPeriodConfig:any;
static setContractType = ($this, value) => {
var oldValue = $this.ContractType;
$this.ContractType = value;
if (value != null) {
}
}
static setBasicSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.BasicSalaries == null) $this.BasicSalaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.BasicSalaries.length > 0) {
                    Domain.EmploymentContractTemplate.removeBasicSalaries($this, $this.BasicSalaries[0]);
                }

                Domain.EmploymentContractTemplate.addManyBasicSalaries($this, copyItems);
            }
static addManyBasicSalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContractTemplate.addBasicSalaries($this, items[i]);
                }
            }
static addBasicSalaries = ($this, item) => {
                if ($this.BasicSalaries == null) $this.BasicSalaries = [];
                if (item == null || $this.BasicSalaries.indexOf(item) > -1) return;
                $this.BasicSalaries.push(item);
}
static addRangeBasicSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContractTemplate.addBasicSalaries($this, item));
            }
static removeBasicSalaries = ($this, item) => {
                if ($this == null || $this.BasicSalaries == null || $this.BasicSalaries.indexOf(item) === -1) return;
                var _index = $this.BasicSalaries.indexOf(item);
                $this.BasicSalaries.splice(_index, 1);
}
static clearBasicSalaries = ($this) => { $this.BasicSalaries = null; }
static setMainSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.MainSalaries == null) $this.MainSalaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MainSalaries.length > 0) {
                    Domain.EmploymentContractTemplate.removeMainSalaries($this, $this.MainSalaries[0]);
                }

                Domain.EmploymentContractTemplate.addManyMainSalaries($this, copyItems);
            }
static addManyMainSalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContractTemplate.addMainSalaries($this, items[i]);
                }
            }
static addMainSalaries = ($this, item) => {
                if ($this.MainSalaries == null) $this.MainSalaries = [];
                if (item == null || $this.MainSalaries.indexOf(item) > -1) return;
                $this.MainSalaries.push(item);
}
static addRangeMainSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContractTemplate.addMainSalaries($this, item));
            }
static removeMainSalaries = ($this, item) => {
                if ($this == null || $this.MainSalaries == null || $this.MainSalaries.indexOf(item) === -1) return;
                var _index = $this.MainSalaries.indexOf(item);
                $this.MainSalaries.splice(_index, 1);
}
static clearMainSalaries = ($this) => { $this.MainSalaries = null; }
static setOtherSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.OtherSalaries == null) $this.OtherSalaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OtherSalaries.length > 0) {
                    Domain.EmploymentContractTemplate.removeOtherSalaries($this, $this.OtherSalaries[0]);
                }

                Domain.EmploymentContractTemplate.addManyOtherSalaries($this, copyItems);
            }
static addManyOtherSalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContractTemplate.addOtherSalaries($this, items[i]);
                }
            }
static addOtherSalaries = ($this, item) => {
                if ($this.OtherSalaries == null) $this.OtherSalaries = [];
                if (item == null || $this.OtherSalaries.indexOf(item) > -1) return;
                $this.OtherSalaries.push(item);
}
static addRangeOtherSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContractTemplate.addOtherSalaries($this, item));
            }
static removeOtherSalaries = ($this, item) => {
                if ($this == null || $this.OtherSalaries == null || $this.OtherSalaries.indexOf(item) === -1) return;
                var _index = $this.OtherSalaries.indexOf(item);
                $this.OtherSalaries.splice(_index, 1);
}
static clearOtherSalaries = ($this) => { $this.OtherSalaries = null; }
static setDeductions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Deductions == null) $this.Deductions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Deductions.length > 0) {
                    Domain.EmploymentContractTemplate.removeDeductions($this, $this.Deductions[0]);
                }

                Domain.EmploymentContractTemplate.addManyDeductions($this, copyItems);
            }
static addManyDeductions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContractTemplate.addDeductions($this, items[i]);
                }
            }
static addDeductions = ($this, item) => {
                if ($this.Deductions == null) $this.Deductions = [];
                if (item == null || $this.Deductions.indexOf(item) > -1) return;
                $this.Deductions.push(item);
}
static addRangeDeductions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContractTemplate.addDeductions($this, item));
            }
static removeDeductions = ($this, item) => {
                if ($this == null || $this.Deductions == null || $this.Deductions.indexOf(item) === -1) return;
                var _index = $this.Deductions.indexOf(item);
                $this.Deductions.splice(_index, 1);
}
static clearDeductions = ($this) => { $this.Deductions = null; }
static setContributions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Contributions == null) $this.Contributions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Contributions.length > 0) {
                    Domain.EmploymentContractTemplate.removeContributions($this, $this.Contributions[0]);
                }

                Domain.EmploymentContractTemplate.addManyContributions($this, copyItems);
            }
static addManyContributions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContractTemplate.addContributions($this, items[i]);
                }
            }
static addContributions = ($this, item) => {
                if ($this.Contributions == null) $this.Contributions = [];
                if (item == null || $this.Contributions.indexOf(item) > -1) return;
                $this.Contributions.push(item);
}
static addRangeContributions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContractTemplate.addContributions($this, item));
            }
static removeContributions = ($this, item) => {
                if ($this == null || $this.Contributions == null || $this.Contributions.indexOf(item) === -1) return;
                var _index = $this.Contributions.indexOf(item);
                $this.Contributions.splice(_index, 1);
}
static clearContributions = ($this) => { $this.Contributions = null; }
static setSalaryPeriodConfig = ($this, items) => {
                if (items == null) items = [];
                if ($this.SalaryPeriodConfig == null) $this.SalaryPeriodConfig = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SalaryPeriodConfig.length > 0) {
                    Domain.EmploymentContractTemplate.removeSalaryPeriodConfig($this, $this.SalaryPeriodConfig[0]);
                }

                Domain.EmploymentContractTemplate.addManySalaryPeriodConfig($this, copyItems);
            }
static addManySalaryPeriodConfig = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContractTemplate.addSalaryPeriodConfig($this, items[i]);
                }
            }
static addSalaryPeriodConfig = ($this, item) => {
                if ($this.SalaryPeriodConfig == null) $this.SalaryPeriodConfig = [];
                if (item == null || $this.SalaryPeriodConfig.indexOf(item) > -1) return;
                $this.SalaryPeriodConfig.push(item);
if (item.EmploymentContractTemplate != $this) {
Domain.EmployeeContractSalaryPeriod.setEmploymentContractTemplate(item, $this);
}
}
static addRangeSalaryPeriodConfig = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContractTemplate.addSalaryPeriodConfig($this, item));
            }
static removeSalaryPeriodConfig = ($this, item) => {
                if ($this == null || $this.SalaryPeriodConfig == null || $this.SalaryPeriodConfig.indexOf(item) === -1) return;
                var _index = $this.SalaryPeriodConfig.indexOf(item);
                $this.SalaryPeriodConfig.splice(_index, 1);
item.EmploymentContractTemplate = null;
}
static clearSalaryPeriodConfig = ($this) => { $this.SalaryPeriodConfig = null; }

static GetClassName(): any{return "EmploymentContractTemplate";
}
static getEmploymentKind(ect: any): any{return ect?.ContractType?.Kind;
}
static getEmploymentRelationshipType(ect: any): any{return ect?.ContractType?.RelationshipType;
}
static getEmploymentType(ect: any): any{return ect?.ContractType?.Category;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}